<template>
  <fieldset>
    <div class="form-group">
      <slot :rowFields="rowFields"></slot>
    </div>
  </fieldset>
</template>
<script>
export default {
  props: {
    rowFields: {
      type: Array,
      default: () => []
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Partials/SettingsForm/FieldSet.vue